import defaultPalette from '../palette';
export default (function (_a) {
    var _b, _c;
    var _d = _a.palette, palette = _d === void 0 ? defaultPalette : _d;
    return {
        MuiTabs: {
            root: {
                '& button:hover': {
                    backgroundColor: (_b = palette === null || palette === void 0 ? void 0 : palette.action) === null || _b === void 0 ? void 0 : _b.hover,
                },
                '& button:focus-visible': {
                    border: "3px solid " + ((_c = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _c === void 0 ? void 0 : _c.main),
                },
            },
        },
    };
});
